export class Comercial {

    constructor({ tipoFrmEmpresa } = {}) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;

        this.model = {
            id: { 
                value: null, 
                export: false },
            idp: { 
                value: null, 
                export: false 
            },
            nombres: {
                value: '', 
                export: false, 
                header: 'Nombre/Razón social', 
                headerPorTipo: {
                    FRM_DIFARE: 'Nombre y Apellido',
                }, 
                required: 'Nombre y apellido es requerido',
                maxLength: 'Máximo 500 caracteres', 
                minLength: 'Mínimo 4 caracteres', 
                max: 500, 
                min: 4, 
                table: true, 
                filter: false, 
                sort: true
            },
            razon_social: {
                value: '', 
                export: false, 
                header: 'Razón social o empresa', 
                required: 'Razón social es requerido',
                maxLength: 'Máximo 300 caracteres', 
                minLength: 'Mínimo 4 caracteres', 
                max: 300, 
                min: 4, 
                table: false, 
                tablePorTipo: {
                    FRM_DIFARE: true,
                },
                filter: false, 
                sort: true
            },
            contacto: {
                value: '', 
                export: true, 
                header: 'Contacto', 
                headerPorTipo: {
                    FRM_DIFARE: 'Cargo',
                }, 
                required: 'Contacto es requerido', 
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres', 
                max: 300, 
                min: 4, 
                table: true,
            },
            telefono_contacto: {
                value: '', 
                export: true, 
                header: 'Teléfono de contacto', 
                headerPorTipo: {
                    FRM_DIFARE: 'Teléfono',
                }, 
                required: 'Teléfono de contacto es requerido',
                maxLength: 'Máximo 100 caracteres', 
                minLength: 'Mínimo 4 caracteres', 
                max: 100, 
                min: 4, 
                table: true,
            },
            tiempo_relacion: {
                value: '', 
                export: true, 
                header: 'Tiempo de la relación comercial / vinculación', 
                required: 'Tiempo de la relación comercial es requerido',
                maxLength: 'Máximo 100 caracteres', 
                minLength: 'Mínimo 4 caracteres', 
                max: 100, 
                min: 4, 
                table: true,
                tablePorTipo: {
                    FRM_DIFARE: false,
                },
            },
        }
        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
            if (campo.tablePorTipo && tipoFrmEmpresa && campo.tablePorTipo[tipoFrmEmpresa] !== undefined) {
                campo.table = campo.tablePorTipo[tipoFrmEmpresa];
            }
        });
    }
}
